<template>
  <expert-layout>
    <v-layout wrap>
      <v-flex sm4><location @location="searchedLocation" ref="location"></location></v-flex>
      <v-flex sm4><search @selectedCategory="assignCategory" ref="search"></search></v-flex>
      <v-flex sm4>
          <v-btn
            v-if="selectedLocation !==null | selectedCategory !== null"
            class="primary" dark flat :loading="loader" @click="searchJobs(1)">
            Search
          </v-btn>
          <v-btn v-else style="background: #C0C0C0">Search</v-btn>
          <v-btn style="background: #C0C0C0" v-if="selectedLocation !==null | selectedCategory !== null" class="primary" dark flat @click="clearSearch()">Clear Search</v-btn>
        </v-flex>
    </v-layout>
    <jobs-list :jobs="jobs"></jobs-list>
    <v-pagination v-if="jobs.length>=1"
        v-model="currentPage"
        :length="Math.ceil(amount/perPage)"
        @input="onPageChange"
    ></v-pagination>
  </expert-layout>
</template>

<script>
import { mapGetters } from "vuex";
import JobsList from "./_components/listing.vue";
import Location from "@/components/shared/location.vue";
import Search from "@/components/shared/search.vue";
export default {
  name: "AllJobsIndex",
  components: {
    JobsList,
    Location,
    Search
  },
  computed: {
    ...mapGetters(["user"])
  },
  data() {
    return {
      jobs: [],
      currentPage: 1,
      perPage: 10,
      amount: 0,
      selectedLocation: null,
      selectedCategory: null,
      loader: false
    };
  },
  methods: {
    async clearSearch() {
      this.$refs.location.clearLocation();
      this.$refs.search.clearCategory();
      this.selectedCategory = null;
      this.selectedLocation = null;
      if(this.selectedCategory == null && this.selectedLocation== null) {
        this.fetchJobs();
      } 
    },
    searchedLocation(data) {
      this.selectedLocation = data
      if(this.selectedCategory == null && this.selectedLocation== null) {
        this.fetchJobs();
      }
    },
    assignCategory(category) {
      this.selectedCategory = category;
      if(category == null && this.selectedLocation== null) {
        this.fetchJobs();
      }
    },
    async searchJobs(page) {
      if (this.selectedCategory == null && this.selectedLocation == null) {
        this.$toast
          .error("Please enter location or expertise to search")
          .goAway(3000);
      } else {
        this.$router.push({query: {page: page}});
        let queryData;
        if (this.selectedCategory == null) {
          const coordinates = [];
          const lat = this.selectedLocation.lat;
          const lng = this.selectedLocation.lng;
          coordinates.push(lat);
          coordinates.push(lng);
          const location = {
            type: "Point",
            coordinates: coordinates
          };
          queryData = {
            location: location,
            page: page
          };
        } else if (this.selectedLocation == null) {
          queryData = {
            category: this.selectedCategory,
            page: page
          };
        } else {
          const coordinates = [];
          const lat = this.selectedLocation.lat;
          const lng = this.selectedLocation.lng;
          coordinates.push(lat);
          coordinates.push(lng);
          const location = {
            type: "Point",
            coordinates: coordinates
          };
          queryData = {
            location: location,
            category: this.selectedCategory,
            page: page
          };
        }

        const self = this;
        self.loader = true;
        const data = { queryData: JSON.stringify(queryData) };
        this.$store.dispatch("postapi", { url: "api/client/filter/jobs", data }).then(res => {
          if (res.jobs.length > 0) {
            self.jobs = res.jobs;
          } else {
            self.jobs = [];
          }
          self.loader = false;
          //self.selectedLocation = null;
          //self.selectedCategory = null;
          self.amount = res.amount;
        });
      }
    },
    getUser() {
      const self = this;
      this.$store.dispatch("get", "/user/" + this.user._id).then(res => {
        if (res.state) {
          const expert = res.user;
          if (expert.expired == true) {
            self.$router.push("/expiry");
          }
        }
      });
    },
    fetchJobs() {
      const userId = this.user._id;
      let cPage = typeof this.$route.query.page != "undefined"
        ? this.$route.query.page
        : 1;
      this.$store.dispatch("get", "/job/all/expert/" + userId+"/"+cPage).then(res => {
        if (res.jobs) {
          this.jobs = res.jobs;
          this.currentPage = Number(cPage);
          this.amount = res.amount;
        }
      });
    },
    onPageChange(page) {
      this.$router.push({query: {page: page}});
      try {
        if (this.selectedCategory == null && this.selectedLocation == null) {
          const userId = this.user._id;
          this.$store.dispatch("get", "/job/all/expert/" + userId+"/"+page).then(res => {
            if (res.jobs) {
              this.jobs = res.jobs;
              this.amount = res.amount;
            }
          });
        } else {
          this.searchJobs(page);
        }
      } catch (err) {
        throw err;
        return { jobs: [] };
      }
    }
  },
  mounted() {
    this.fetchJobs();
  },
  created() {
    this.getUser();
    this.fetchJobs();
  }
};
</script>
